import classnames from 'classnames'
import { FunctionalComponent, ComponentChildren } from 'preact'

export interface ModalProps {
  isOpen?: boolean
  className?: string
  onClose?: () => void
  children: ComponentChildren
}

const Modal: FunctionalComponent<ModalProps> = (props) => (
  <div>
    {props.isOpen && (
      <div className={classnames('react-modal-container', props.className)}>
        <div className='react-modal-opacity' />
        <div className='react-modal'>
          <div className='react-modal_close-button-container'>
            <i
              className='icon icon--cross close react-modal_close-button'
              onClick={(e) => {
                props.onClose?.()
                e.stopPropagation()
              }}
            />
          </div>
          {props.children}
        </div>
      </div>
    )}
  </div>
)

export default Modal
